<template>
    
    <el-drawer :before-close="freshdata" v-model="showlabel" title="设置显示标签" direction="rtl">
        <div class="label-btn">
            <wcbutton :option="{title:'刷新数据'}" @click="freshdata" class="right10" />
            <wcbutton :option="{title:'保存',type:'del'}" @click="savedata()" />
        </div>
        <div class="label-box top20">
            <div class="label-box-info" v-for="(item,index) in labellist" :key="index">
                <div class="ttl-checkbox">
                <el-checkbox v-model="item.value" />
                </div>
                <div class="left10 label-name">{{item.name}}</div>
            </div>
        </div>
    </el-drawer>

</template>


<script>
import INTERFACE_MODEL_SHOP from '@/Interface/Shop/pagelabel';
export default {
    props: ['value','type'],
    data() {
        return {
           showlabel:false,
           labellist:[]
        }
    },

    watch: {
        value(val) {
            if(val){
                this.showlabel=true;
                this.getPageLabel();
            }
        }
    },

    mounted() {
        
    },

    methods: {

        //获取label信息
        getPageLabel() {
            INTERFACE_MODEL_SHOP.GET_PAGE_LABEL_INFO({type:this.type}).then(res => {
                this.labellist=res.data;
            })
        },

        //刷新数据
        freshdata() {
            this.showlabel=false;
            this.$emit('finish');
        },

        //保存数据
        savedata() {
            var data={};
            for(var i=0; i < this.labellist.length; i++) data[this.labellist[i].label]=this.labellist[i].value;
            INTERFACE_MODEL_SHOP.SET_PAGE_LABEL({type:this.type,data:JSON.stringify(data)}).then(res => {
                this.freshdata();
            })
        }

    },

}
</script>
<style lang="scss" Scoped>
    .label-btn {display: flex;justify-content:flex-end;width: 100%;}
    .label-box {display: inline-block;width: 100%;}
    .label-box-info {display: inline-flex;align-items:center;width: 100%;padding:15rpx 0;}
    .label-name {font-size:13px;color:#333333;}
</style>